import { environment } from 'src/environments/environment';
import { TemplateLogoData } from './template-logo.data';
import { Template } from 'src/app/display/template';
import { ContextData } from 'src/app/data/context.data';

declare const fabric: any;

export class TemplateData {

  private _data:any;

  private _svg:string;
  private _folds:Array<any>;
  private _logo:TemplateLogoData;

  public borderB64:string;

  // tempalte
  private _template: Template;

  constructor(data:any = null) {
    if (data) {
      this.setData(data);
    }
  }

  public computeBase64Border(){
    // console.log("TemplateData.computeBase64Border()");
    let _c = fabric.util.createCanvasElement();
    _c.width=this._template.shapeForPrint.width+1;
    _c.height=this._template.shapeForPrint.height+1;

    let _borderForPrint = fabric.util.object.clone(this._template.shapeForPrint);
    _borderForPrint.set({
      evented: false,
      fill: 'transparent',
      strokeWidth: 1,
      stroke: '#878787'
    });

    let _mask = fabric.util.object.clone(this._template.shapeForPrint);
    _mask.set({
      evented: false,
      left:this._template.shapeForPrint.width*-.5,
      top:this._template.shapeForPrint.height*-.5
    });
    _mask.inverted = true;
    let _masker = new fabric.Rect({
        evented: false,
        clipPath: _mask,
        width: this._template.shapeForPrint.width,
        height: this._template.shapeForPrint.height,
        fill: 'white',
      });

    let _s = new fabric.Canvas(_c, {enableRetinaScaling:false});
    _s.add(_masker);
    _s.add(_borderForPrint);
    _s.setBackgroundColor('rgba(0, 0, 0, 0)');
    _s.renderAll();
    this.borderB64 = _s.toDataURL({format:'png'});
    _s.dispose();
    _s = null;
    _c = null;
  }

  /**
	 * data
	 */
  public setData(value: any):Promise<boolean> {
    this._data = value;

    this._folds = [];

    if (this._data.folds) {
      for (var i:number = 0; i < this._data.folds.length; i++) {
        var xFrom:number = +this._data.folds[i][0][0] * ContextData.MM_TO_PIXELS;
        var yFrom:number = +this._data.folds[i][0][1] * ContextData.MM_TO_PIXELS;
        var xTo:number = +this._data.folds[i][1][0] * ContextData.MM_TO_PIXELS;
        var yTo:number = +this._data.folds[i][1][1] * ContextData.MM_TO_PIXELS;

        this._folds.push({xFrom:xFrom, yFrom:yFrom, xTo:xTo, yTo:yTo});
      }
    }


    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest;
      xhr.open('GET', environment.ASSETS_SERVER + this._data.svgSrc);
      xhr.responseType = 'text';
      xhr.overrideMimeType('text/xml');
      xhr.onload = () => {

        if (xhr.readyState === xhr.DONE) {
          if (xhr.status === 200) {
            this._svg = xhr.responseText;
            // console.log(xhr.responseXML);
            // for (var i:int = 0; i < _svg.children().length(); i++) {
            //   if (_svg.children()[i].@["stroke-width"] && String(_svg.children()[i].@["stroke-width"]).length > 0) {
            //     _svg.children()[i].@["stroke-width"] = "2";
            //   }
            // }

            if (this._data.logo) {
              this._logo = new TemplateLogoData();
              this._logo.setData(this._data.logo).then(
                (result: any) => {
                  this._template = new Template(this);
                  resolve(true);
                },
                (error: any) => {
                  reject(false);
                },
              ).catch((e: Error) => { console.error(e); reject(e); });
            } else {
              this._template = new Template(this);
              resolve(true);
            }

          } else {
            reject(false);
          }
        }
      };
      xhr.send();
    });
  }

  /**
   * svg
   */
  public get svg():string {
    return this._svg;
  }

  /**
   * Width
   */
  public get width():number {
    return this._data.width;
  }
  public get pixelsWidth():number {
    return this.width * ContextData.MM_TO_PIXELS;
  }

  /**
   * Height
   */
  public get height():number {
    return this._data.height;
  }
  public get pixelsHeight():number {
    return this.height * ContextData.MM_TO_PIXELS;
  }


  /**
   * Folds
   */
  public get folds():Array<any> {
    return this._folds;
  }

  /**
   * Get default text style
   */
  public get defaultTextStyle():any {
    var font:string = this._data.defaultTextStyle.font ? this._data.defaultTextStyle.font : null;
    var size:number = this._data.defaultTextStyle.size ? +this._data.defaultTextStyle.size : NaN;
    var color:number = this._data.defaultTextStyle.color ? +this._data.defaultTextStyle.color : NaN;

    return {font:font, size:size, color:color};
  }

  /**
   * Template ID
   */
  public get id():number {
    return this._data.id;
  }

  /**
   * Logo
   */
  public get logo():TemplateLogoData {
    return this._logo;
  }

  /**
   * Masker
   */
  get shapeMasker(): any {
    return this._template.shapeMasker;
  }

  /**
   * PrintedArea
   */
  get printedArea(): any {
    return this._template.printedArea;
  }

  /**
   * Border
   */
  get border(): any {
    return this._template.border;
  }


  /**
   * Shape
   */
  get shape(): any {
    return this._template.shape;
  }

  /**
   * Template
   */
  get template(): any {
    return this._template;
  }

  /**
   * Cleanup
   */
  public cleanup():void {
    this._data = null;
    this._svg = null;
    this._folds = null;

    if (this._logo) {
      this._logo.cleanup();
    }
    this._logo = null;
  }

}
